var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.87107 5.1343L17.3405 2.2194C17.7882 2.0447 18.012 1.95736 18.155 2.00514C18.2792 2.04663 18.3767 2.1441 18.4182 2.26831C18.466 2.41133 18.3786 2.63516 18.2039 3.08281L15.2797 10.5761M14.0783 13.6548L12.712 17.1559C12.5184 17.6518 12.4217 17.8998 12.2826 17.972C12.162 18.0347 12.0185 18.0346 11.898 17.9718C11.759 17.8994 11.6625 17.6513 11.4696 17.1552L9.27948 11.5235C9.24032 11.4228 9.22074 11.3725 9.19049 11.3301C9.16369 11.2925 9.13082 11.2596 9.09324 11.2328C9.05084 11.2026 9.00048 11.183 8.89978 11.1438L3.26811 8.95373C2.77199 8.7608 2.52393 8.66433 2.4515 8.52533C2.38872 8.40483 2.38864 8.26129 2.45128 8.14071C2.52354 8.00162 2.77148 7.90486 3.26738 7.71134L6.77147 6.3439M17.9232 17.5001L2.92317 2.50014",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.e2daeb346454b0c66a6d41185d8e519c.svg";
export { ForwardRef as ReactComponent };